import useRecently from "./useRecently";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import LaundryModal from "../LaundryModal/LaundryModal.js";
import { getTranslatedText as translate } from "../../Localization/Translation";

const RecentlyUsed = () => {
  const { locale, show, LaundCards, handleClose } = useRecently();

  return (
    <div
      className="SearchWasher-component"
      dir={locale === "EN" || locale === "HN" ? "ltr" : "rtl"}
    >
      <div className="Launds-search-list row">{LaundCards}</div>

      <Modal show={show} onHide={handleClose} size="md" dir="auto">
        <Modal.Body>
          <LaundryModal />
        </Modal.Body>
        <Modal.Footer dir="auto">
          <Button
            variant="primary"
            className="btn btn-calendar-modal-save"
            onClick={handleClose}
          >
            {translate("modal-ok-btn", locale)}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RecentlyUsed;
